import React from "react"
import SEO from "../components/molecules/seo"
import Seminar from "../components/templates/Seminar"

const SeminarPage = () => (
  <>
    <SEO
      title="ゼミについて"
      keywords={[
        `片平ゼミ`,
        `片平`,
        `ゼミ`,
        `東京大学`,
        `経済学部`,
        `ブランド`,
        `丸の内`,
        `自主ゼミ`,
      ]}
    />
    <Seminar />
  </>
)

export default SeminarPage
